import React, { useContext, useEffect, useRef, useState } from "react";
import Footer from "../../Components/Footer/Footer";
// import Nav from "../../Components/Nav/Nav";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Nav from "../../Components/Navnew/Nav";
import Klik from "../../Asset/click.png";
import Payme from "../../Asset/payme.png";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

const OneTour = () => {
  let { id } = useParams();
  let location = useLocation()
  // console.log(location.search.includes('price'), 'location')
  const urlParams = new URLSearchParams(location.search);

// Get the value of the 'price' parameter
const price = urlParams.get("price");

  const { t, i18n } = useTranslation();
  const [data, setData] = useState({});
  const [paymeShow, setPaymeShow] = useState(false);
  const [clickShow, setClickShow] = useState(false);
  const [bookShow, setBookShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [notSuccess, setNotSuccess] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [accessCode, setAccessCode] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerContact, setCustomerContact] = useState("");
  const [accessLoading, setAccessLoading] = useState(false);
  const [accessSuccess, setAccessSuccess] = useState(false);
  const [receiptInfo, setReceiptInfo] = useState({
    email: "payment@example.com",
    telegram: "@payment_support",
  });
  const [termsWarning, setTermsWarning] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const API_BASE_URL = "https://tur.web-sayt.uz/api";
  const lang = window.localStorage.getItem("lang")
    ? window.localStorage.getItem("lang")
    : "en";
  const paymentCopy = {
    uz: {
      title: "To'lovga ruxsat",
      code: "Kirish kodi",
      email: "Email",
      name: "Ism",
      contact: "Telegram yoki telefon raqami",
      submit: "Yuborish",
      loading: "Tekshirilmoqda...",
      successTitle: "Kirish kodi tasdiqlandi",
      successText: "Iltimos, muvaffaqiyatli to'lov chekini emailga:",
      orTelegram: "yoki Telegramga:",
      sendReceipt: "yuboring.",
    },
    ru: {
      title: "Доступ к оплате",
      code: "Код доступа",
      email: "Email",
      name: "Имя",
      contact: "Telegram или номер телефона",
      submit: "Отправить",
      loading: "Проверка...",
      successTitle: "Код доступа подтвержден",
      successText: "Пожалуйста, отправьте чек успешной оплаты на email:",
      orTelegram: "или в Telegram:",
      sendReceipt: "после оплаты.",
    },
    en: {
      title: "Payment access",
      code: "Access code",
      email: "Email",
      name: "Name",
      contact: "Telegram or phone number",
      submit: "Submit",
      loading: "Checking...",
      successTitle: "Access code confirmed",
      successText: "Please send the successful payment receipt to email:",
      orTelegram: "or Telegram:",
      sendReceipt: "after payment.",
    },
  }[lang] || {};
  // const [lang, setLanguage] = useState('en')
  // useEffect(()=>{
  //   setLanguage(localStorage.getItem("lang"))
  // },[localStorage])
  let dollar = 11.7;
  const [isloading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    fetch(`${API_BASE_URL}/tours/${id}`)
      .then((res) => res.json())
      .then((response) => {
        const tour = response?.data?.tour?.[0] || {};
        setData(tour);
        console.log(tour);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [id]);

  const formBtn = (e) => {
    setTimeout(() => {
      setSuccess(true);
      setBookShow(false);
    }, 1000);
    e.preventDefault();
    if (e.target[0].value.length > 0 && e.target[1].value.length > 0) {
      let botMessege = `
      Здравствуйте, администратор UZTURAGENCY, новое сообщение! 😊%0A
      Название тура  : ${data.title_eng}%0A
      Имя    👤: ${e.target[0].value}%0A
      Фамилия   👤: ${e.target[1].value}%0A
      Телефон номер   📧: ${e.target[1].value}%0A
      `;

      let url = `https://api.telegram.org/bot7859889008:AAHIkSdCOwbYoxmTwIble9J2FXlAKES8vRk/sendMessage?chat_id=-4535883531&text=${botMessege}`;
      async function fetchAsync(url) {
        let response = await fetch(url);
        let data = await response.json();
        return data;
      }
      fetchAsync(url);
      e.target[0].value = "";
      e.target[1].value = "";
      e.target[2].value = "";
    } else {
      setNotSuccess(true);
    }
  };
  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  
  const Pay = async()=>{
    if (!termsAccepted) {
      setTermsWarning(true);
      return;
    }
    const paymentPrice = price ? price : data?.price;
    let form_data = {
      "octo_shop_id": 20216,
      "octo_secret": "e76f93fb-b5da-4a92-93e5-1c51d2c9c3e8",
      "shop_transaction_id": uuidv4(),
      "auto_capture": true,
      // "test": true,
      "init_time": formatDate(new Date()),
      // "total_sum": 0.5,
      "total_sum": paymentPrice,
      "currency": "USD",
      "description": data?.title_ru,
      "return_url": "https://www.uzturagency.uz/",
      // "notify_url": "https://webhook.site/7e378456-96f4-4aa2-b531-a9bd2cf66bc3", 
      "language": "ru"
    }
    await axios.post(`${API_BASE_URL}/tours/octo`, 
      {
      title_ru: data?.title_ru,
      price: paymentPrice,
      }
    ).then((res)=>{
      console.log(res, 'res')
      window.open(res.data.octo_pay_url)
    }).catch((err)=>{
      console.log(err)
    })
  }
  const isAccessFormReady =
    accessCode.trim() &&
    customerEmail.trim() &&
    customerName.trim() &&
    customerContact.trim() &&
    termsAccepted;

  const VerifyPaymentAccess = async (e) => {
    e.preventDefault();
    if (!isAccessFormReady || !id) {
      setTermsWarning(true);
      return;
    }

    setAccessLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/payment-access/verify`, {
        tourId: id,
        accessCode,
        email: customerEmail,
        name: customerName,
        contact: customerContact,
        termsAccepted,
      });

      setReceiptInfo({
        email: response?.data?.data?.receiptEmail || "payment@example.com",
        telegram: response?.data?.data?.receiptTelegram || "@payment_support",
      });
      setAccessSuccess(true);
      setAccessCode("");
      setCustomerEmail("");
      setCustomerName("");
      setCustomerContact("");
      setTermsAccepted(false);
    } catch (err) {
      console.log(err);
      setNotSuccess(true);
    } finally {
      setAccessLoading(false);
    }
  };
  return (
    <>
      <SweetAlert
        danger
        confirmBtnText="ok"
        confirmBtnBsStyle="danger"
        title={t("not")}
        show={notSuccess}
        onConfirm={() => setNotSuccess(false)}
        focusCancelBtn
      />
      <SweetAlert
        danger
        confirmBtnText="ok"
        confirmBtnBsStyle="danger"
        title={t("payment_terms_required")}
        show={termsWarning}
        onConfirm={() => setTermsWarning(false)}
        focusCancelBtn
      />
      <SweetAlert
        success
        title={t("msent")}
        show={success}
        onConfirm={() => window.location.reload()}
      />
      <SweetAlert
        success
        title={paymentCopy.successTitle}
        show={accessSuccess}
        onConfirm={() => setAccessSuccess(false)}
      >
        <p style={{ marginBottom: 0 }}>
          {paymentCopy.successText} <strong>{receiptInfo.email}</strong>{" "}
          {paymentCopy.orTelegram} <strong>{receiptInfo.telegram}</strong>{" "}
          {paymentCopy.sendReceipt}
        </p>
      </SweetAlert>
      <SweetAlert
        title={t("info")}
        show={bookShow}
        onCancel={() => setBookShow(false)}
        onConfirm={() => {}}
        showConfirm={false}
      >
        <div>
          <form onSubmit={formBtn}>
            <input className="form-control" placeholder={t("name")} required />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("surname")}
              required
            />
            <input
              className="form-control"
              style={{ margin: "10px 0px" }}
              placeholder={t("number")}
              required
            />
            <button
              className="money glow-on-hover"
              style={{ color: "black", backgrounColor: "white" }}
              onClick={() => {}}
            >
              {t("send")}
            </button>
          </form>
        </div>
      </SweetAlert>
      <SweetAlert
        title={"Payment wih PAYME"}
        show={paymeShow}
        onCancel={() => setPaymeShow(false)}
        onConfirm={() => {}}
        showConfirm={false}
      >
        <div>
          <input
            className="form-control"
            placeholder={"Full name"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <input
            className="form-control"
            style={{ margin: "10px 0px" }}
            placeholder={"Phone Number"}
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          />
          <form method="POST" action="https://checkout.paycom.uz">
            {" "}
            <input
              type="hidden"
              name="merchant"
              defaultValue="64b27ea2d2cbaa16838ebe1e"
            />{" "}
            <input
              type="hidden"
              name="amount"
              defaultValue={Number((data?.price || 0) * 11700)+"00"}
            />{" "}
            <input type="hidden" name="account[nazvaniya]" defaultValue={name} />{" "}
            <input
              type="hidden"
              name="account[Nomer]"
              defaultValue={phoneNumber}
            />{" "}
            <input type="hidden" name="account[sum]" defaultValue={Number((data?.price || 0) * 11700)+"00"} />{" "}
            <button type="submit" className="money glow-on-hover">
              {" "}
              <img src={Payme} />{" "}
            </button>{" "}
          </form>
             {/* <form method="POST" action="https://checkout.paycom.uz"> <input type="hidden" name="merchant" value="64b27ea2d2cbaa16838ebe1e"/> <input type="hidden" name="amount" value="100000"/> <input type="hidden" name="account[nazvaniya]" value="aZIMJON"/> <input type="hidden" name="account[Nomer]" value="998909541262"/> <button type="submit" style="cursor: pointer;
border: 1px solid #ebebeb;
border-radius: 6px;
background: linear-gradient(to top, #f1f2f2, white);
width: 200px;
height: 42px;
display: flex;
align-items: center;
justify-content: center;"> <img style="width: 160px;
height: 20px;" src="http://cdn.payme.uz/buttons/buttonbig_EN.svg"/> </button> </form> */}
        </div>
      </SweetAlert>
      <SweetAlert
        title={"Payment wih Click"}
        show={clickShow}
        onCancel={() => setClickShow(false)}
        onConfirm={() => {}}
        showConfirm={false}
      >
        <div>
          <input
            className="form-control"
            placeholder={"Full name"}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <input
            className="form-control"
            style={{ margin: "10px 0px" }}
            placeholder={"Phone Number"}
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          />
          <form
            id="click_form"
            className="text-center  w-80 text-white rounded-md cursor-pointer  text-3xl font-bold"
            action="https://my.click.uz/services/pay"
            method="get"
            target="_blank"
          >
            <input
              type="hidden"
              name="amount"
              value={(data?.price || 0) * dollar * 1000}
            />
            <input type="hidden" name="merchant_id" value="20898" />
            <input type="hidden" name="merchant_user_id" value="33539" />
            <input type="hidden" name="service_id" value="28519" />
            <input type="hidden" name="transaction_param" value={name} />
            <input
              type="hidden"
              name="return_url"
              value="https://www.UZTURAGENCY.uz/"
            />
            <input type="hidden" name="card_type" value="uzcard" />
            <button type="submit" className="money glow-on-hover">
              {" "}
              <img src={Klik} />{" "}
            </button>{" "}
          </form>
        </div>
      </SweetAlert>
      {isloading ? (
        <div className="load-wrap">
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <>
          <Nav />
          <head>
            <link
              href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css"
              rel="stylesheet"
              integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65"
              crossorigin="anonymous"
            />
          </head>

          {/* endnav */}
          <div className="container hihello" style={{ marginBottom: "6rem" }}>
            <div className="leftg">
              <img
                src={`${data?.img || ""}`}
                alt="Hawaii"
                style={{ borderRadius: "10px" }}
              />
            </div>
            <div className="rightg">
              <h2>
                {lang === "en" && data?.title_eng}
                {lang === "ru" && data?.title_ru}
                {lang === "uz" && (data?.title_uz || data?.title_ru)}
              </h2>
              <p></p>
              <p>
                {data?.location}
                <br />
                {price ? price : data?.price} $
                <br />
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "en"
                        ? data?.description_eng
                        : lang === "uz"
                          ? (data?.description_uz || data?.description_ru)
                          : data?.description_ru,
                  }}
                >
                </div>
              </p>
              <form
                onSubmit={VerifyPaymentAccess}
                style={{
                  marginTop: "22px",
                  borderRadius: "14px",
                  padding: "24px",
                  background: "#f8fbff",
                  border: "1px solid #d0e4f5",
                  boxShadow: "0 4px 24px rgba(12,139,203,0.08)",
                }}
              >
                {/* Title */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                  <div style={{
                    width: "36px", height: "36px", borderRadius: "50%",
                    background: "#0c8bcb",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                  </div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: "#1a3a4a", fontSize: "17px" }}>{paymentCopy.title}</h5>
                </div>

                {/* Access Code */}
                <div style={{ position: "relative", marginBottom: "12px" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#0c8bcb", pointerEvents: "none" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/>
                    </svg>
                  </span>
                  <input
                    placeholder={paymentCopy.code}
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                    required
                    style={{
                      width: "100%", paddingLeft: "40px", paddingRight: "14px",
                      height: "46px", borderRadius: "10px",
                      border: "1.5px solid #ccdff0", outline: "none",
                      fontSize: "14px", background: "#fff", color: "#1a3a4a",
                      boxSizing: "border-box", transition: "border-color 0.2s",
                    }}
                    onFocus={e => e.target.style.borderColor = "#0c8bcb"}
                    onBlur={e => e.target.style.borderColor = "#ccdff0"}
                  />
                </div>

                {/* Email */}
                <div style={{ position: "relative", marginBottom: "12px" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#0c8bcb", pointerEvents: "none" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </span>
                  <input
                    placeholder={paymentCopy.email}
                    type="email"
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    required
                    style={{
                      width: "100%", paddingLeft: "40px", paddingRight: "14px",
                      height: "46px", borderRadius: "10px",
                      border: "1.5px solid #ccdff0", outline: "none",
                      fontSize: "14px", background: "#fff", color: "#1a3a4a",
                      boxSizing: "border-box", transition: "border-color 0.2s",
                    }}
                    onFocus={e => e.target.style.borderColor = "#0c8bcb"}
                    onBlur={e => e.target.style.borderColor = "#ccdff0"}
                  />
                </div>

                {/* Name */}
                <div style={{ position: "relative", marginBottom: "12px" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#0c8bcb", pointerEvents: "none" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                    </svg>
                  </span>
                  <input
                    placeholder={paymentCopy.name}
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    required
                    style={{
                      width: "100%", paddingLeft: "40px", paddingRight: "14px",
                      height: "46px", borderRadius: "10px",
                      border: "1.5px solid #ccdff0", outline: "none",
                      fontSize: "14px", background: "#fff", color: "#1a3a4a",
                      boxSizing: "border-box", transition: "border-color 0.2s",
                    }}
                    onFocus={e => e.target.style.borderColor = "#0c8bcb"}
                    onBlur={e => e.target.style.borderColor = "#ccdff0"}
                  />
                </div>

                {/* Telegram / Phone */}
                <div style={{ position: "relative", marginBottom: "16px" }}>
                  <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#0c8bcb", pointerEvents: "none" }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.6 19.79 19.79 0 0 1 1.61 5.07 2 2 0 0 1 3.6 2.87h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 17z"/>
                    </svg>
                  </span>
                  <input
                    placeholder={paymentCopy.contact}
                    value={customerContact}
                    onChange={(e) => setCustomerContact(e.target.value)}
                    required
                    style={{
                      width: "100%", paddingLeft: "40px", paddingRight: "14px",
                      height: "46px", borderRadius: "10px",
                      border: "1.5px solid #ccdff0", outline: "none",
                      fontSize: "14px", background: "#fff", color: "#1a3a4a",
                      boxSizing: "border-box", transition: "border-color 0.2s",
                    }}
                    onFocus={e => e.target.style.borderColor = "#0c8bcb"}
                    onBlur={e => e.target.style.borderColor = "#ccdff0"}
                  />
                </div>

                {/* Checkbox */}
                <label htmlFor="terms-accept" style={{
                  display: "flex", alignItems: "flex-start", gap: "10px",
                  cursor: "pointer", marginBottom: "18px", padding: "12px",
                  borderRadius: "10px",
                  background: termsAccepted ? "rgba(12,139,203,0.07)" : "#f5f8fc",
                  border: `1.5px solid ${termsAccepted ? "#0c8bcb" : "#dde8f0"}`,
                  transition: "all 0.2s",
                }}>
                  <input
                    id="terms-accept"
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    style={{ marginTop: "2px", width: "16px", height: "16px", accentColor: "#0c8bcb", cursor: "pointer", flexShrink: 0 }}
                  />
                  <span style={{ fontSize: "12px", lineHeight: "1.55", color: "#445566" }}>
                    {t("payment_terms_accept")}
                  </span>
                </label>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={!isAccessFormReady || accessLoading}
                  style={{
                    width: "100%", height: "48px", borderRadius: "10px",
                    border: "none",
                    cursor: isAccessFormReady && !accessLoading ? "pointer" : "not-allowed",
                    background: isAccessFormReady && !accessLoading
                      ? "#0c8bcb"
                      : "#c8dce8",
                    color: "#fff", fontWeight: 700, fontSize: "15px",
                    letterSpacing: "0.3px", transition: "all 0.25s",
                    boxShadow: isAccessFormReady && !accessLoading ? "0 4px 14px rgba(12,139,203,0.3)" : "none",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  }}
                >
                  {accessLoading ? (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                      </svg>
                      {paymentCopy.loading}
                    </>
                  ) : (
                    <>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                      </svg>
                      {paymentCopy.submit}
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>



          <Footer />
        </>
      )}
    </>
  );
};

export default OneTour;
